import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { FieldType, FieldTypeConfig } from '@ngx-formly/core'

export interface ChoiceSectionOption {
	icon: string
	label: string
	highlightText: string
	value: string
}

@Component({
	selector: 'gwc-choice-sections',
	templateUrl: './choice.sections.component.html',
	styleUrls: ['./choice.sections.component.scss'],
	imports: [
		CommonModule,
		MatButtonModule,
		MatIconModule
	]
})

export class ChoiceSectionsComponent extends FieldType<FieldTypeConfig> implements OnInit {
	public sections: ChoiceSectionOption[] = []

	ngOnInit(): void {
		this.sections = this.props['options'] as ChoiceSectionOption[]
	}

	public selectSection(option: ChoiceSectionOption): void {
		this.formControl.patchValue(option.value)
	}
}
